import React from 'react'
import cx from 'classnames'
import { useCallback, useMedia } from 'sb-hooks'

import { Image } from 'components/_new/ui'
import { Href } from 'components/_new/controls'
import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './NoteWithStat.scss'


type NoteWithStatProps = {
  className?: string
  name: string
  image: string
  productsCount?: number
  standalone?: boolean
  to?: string
  onClick?: (name: string) => void
  dataTestId?: string
}

const NoteWithStat: React.FunctionComponent<NoteWithStatProps> = (props) => {
  const { className, name, image, productsCount, standalone, to, onClick, dataTestId } = props
  const { isMobile, isDesktop } = useMedia()

  const isLink = Boolean(to) || Boolean(onClick)

  const handleClick = useCallback(() => {
    if (typeof onClick === 'function') {
      onClick(name)
    }
  }, [ onClick, name ])

  const content = (
    <Box
      pt={isDesktop ? null : 16}
      pb={16}
      pl={isMobile ? 8 : 16}
      pr={isMobile ? 8 : 16}
      className={s.note}
    >
      <Box mb={16} className={s.imageContainer}>
        <Image className={s.image} src={image} alt={name} w={isMobile ? 100 : 200} x2 resizeBy="width" />
      </Box>
      <Text
        size={standalone && !isMobile ? '28-40' : '14-24'}
        message={name}
        semibold
        className={s.name}
      />
      {
        (productsCount >= 0) && (
          <Text
            message={{ ...messages.productsCount, values: { productsCount } }}
            size="12-16"
            muted
            className={s.productsCount}
          />
        )
      }
    </Box>
  )

  const rootProps = {
    className: cx(s.root, className, { [s.link]: isLink, [s.standalone]: standalone }),
    'data-testid': dataTestId,
  }

  if (isLink) {
    return (
      <Href to={to} onClick={handleClick} {...rootProps}>
        {content}
      </Href>
    )
  }

  return (
    <div {...rootProps}>
      {content}
    </div>
  )
}


export default NoteWithStat
